import React, { useContext } from "react";

import {
  DeviceTesterStateContext,
  DeviceTesterDispatchContext,
} from "./DeviceTesterContext";
import { useDeviceTester } from "./useDeviceTester";

//context provider for the Device Tester Reducer Dispatch
export const DeviceTesterContextProvider: React.FC<React.PropsWithChildren<any>> = ({
  children,
}) => {
  const deviceSettings = useDeviceTester();
  return (
    <DeviceTesterStateContext.Provider value={deviceSettings}>
      <DeviceTesterDispatchContext.Provider value={deviceSettings}>
        {children}
      </DeviceTesterDispatchContext.Provider>
    </DeviceTesterStateContext.Provider>
  );
};

export const useDeviceTesterStateContext = () =>
  useContext(DeviceTesterStateContext);

export const useDeviceTesterDispatchContext = () =>
  useContext(DeviceTesterDispatchContext);
